import React from 'react';
import { Chip } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { FDataGrid, FGridMoneyCell } from '../grid';

type Props = {
  rows: any[];
  selectedId?: any;
  loading?: boolean;
  onSelect: (row: any) => void;
};

const stageColor = (v: any): any => {
  const s = String(v || '').toUpperCase();
  if (s.includes('ADOPT')) return 'success';
  if (s.includes('CA')) return 'warning';
  if (s.includes('DG')) return 'info';
  return 'default';
};

class BudgetVersionGrid extends React.Component<Props> {
  columns: GridColDef[] = [
    { field: 'shc', headerName: 'Version Code', width: 180 },
    { field: 'nam', headerName: 'Version Name', flex: 1, minWidth: 260 },
    { field: 'fyr', headerName: 'Year', width: 100 },
    { field: 'vty', headerName: 'Type', width: 130 },
    { field: 'aps', headerName: 'Stage', width: 140, renderCell: (p) => <Chip size="small" label={p.value || '-'} color={stageColor(p.value)} /> },
    { field: 'linecount', headerName: 'Lines', width: 100, type: 'number' },
    { field: 'totalbudget', headerName: 'Total', width: 160, renderCell: FGridMoneyCell },
  ];

  render() {
    return (
      <FDataGrid
        title="Budget Versions"
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        height={380}
        showQuickFilter
        toolbarSx={{ backgroundColor: '#eaf2fb' }}
        getRowId={(row: any) => row.rid || row.id}
        onRowClick={(params: any) => this.props.onSelect(params.row)}
        getRowClassName={(params: any) => String(params.row.rid || params.row.id) === String(this.props.selectedId) ? 'selected-version-row' : ''}
        sx={{
          '& .selected-version-row': { bgcolor: '#e3f2fd' },
          '& .MuiDataGrid-row': { cursor: 'pointer' },
        }}
        pageSizeOptions={[10, 25, 50]}
      />
    );
  }
}

export default BudgetVersionGrid;
